import classNames from 'classnames'
import { FC, ReactNode } from 'react'

import { Card, Modal } from '@mui/material'
import { Box } from '@mui/system'

import styles from './GRModal.module.scss'

type GRModalProps = {
  children?: ReactNode
  open: boolean
  onClose: (event: any, reason: string) => void
  size?: 'tiny' | 'small' | 'medium' | 'large' | 'fullscreen'
  // Optional a11y labelling. When provided, the inner dialog surface is marked
  // as a labelled modal dialog. Existing callers omit these and behave unchanged.
  ariaLabelledby?: string
  ariaLabel?: string
}

export const GRModal: FC<GRModalProps> = ({ open, size = 'medium', onClose, children, ariaLabelledby, ariaLabel }) => {
  const classes = classNames(styles.root, styles[size])
  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Box component={Card} className={classes} elevation={3} role="dialog" aria-modal aria-labelledby={ariaLabelledby} aria-label={ariaLabel} tabIndex={-1}>
        {children}
      </Box>
    </Modal>
  )
}
